<template>
<!-- <div>テスト</div> -->
<div class="whole-wrap">
  <BurgerMenuComponent :isGradation="false" />

  <div class="pdf" id="pdfContents">
    <div class="pdf-top">
      <div class="pdf-top-left">
        <div class="pdf-top-name">{{ $t('subject.name') }}</div>
        <div class="pdf-top-emptiness"></div>
        <div class="pdf-top-name">{{ $t('subject.honorific') }}</div>
      </div>
      <div class="pdf-top-right">
        <div style="font-weight: 500;" class="pdf-top-right-item">${subjectId}</div>
        <div style="font-weight: 500;" class="pdf-top-right-item">${genderText}</div>
        <div style="font-weight: 500;" class="pdf-top-right-item">${age}{{ $t('subject.years_old_suffix') }}</div>
      </div>
    </div>
    <div class="border-image"></div>

    <div class="pdf-title"></div>
    <div style="display: flex; align-items: center">
      <img src="data:image/png;base64,${readFileSync('public/img/pdf-title-strong.png').toString('base64')}" style="width: 144.37px; height: 26.4px" />
      <img src="data:image/png;base64,${readFileSync('public/img/pdf-title.png').toString('base64')}" style="width: 232.23px; height: 26.43px; margin-left: 14px" />
    </div>

    <div class="pdf-explanation" v-html="$t('report.pdf_explanation')">
    </div>
    <div class="pdf-main">
      <img src="data:image/png;base64,${readFileSync('public/img/woman-report.png').toString('base64')}" style="position: absolute; right: 16px; top: -103px; width: 98px; height: 130px" />
      <div class="measure-result-list">
        <div class="measure-result-item measure-result-item--pdf measure-result-item--pa" :id="[pdfContents-pa]" style="max-height: 380px; max-width:253px">
          <div class="measure-result-item-audio"></div>
          <div class="measure-result-item-top">
            <div class="measure-result-item-title" style="font-weight: 700;">${getGraphText['pa'][0]}</div>
            <div class="measure-result-item-explanation" style="font-weight: 400;">${getGraphText['pa'][1]}</div>
          </div>
          <div class="measure-result-item-main">
            <div class="top-wrap">
              <div class="measure-result-item-img"><img src="data:image/png;base64,${readFileSync('public/img/mouth-pa.png').toString('base64')}"/></div>
              <div style="font-weight: 700;" class="num-wrap">
                ${explanation['pa']}
                <div class="num-explanation" style="font-weight: 400;">{{ $t('report.passing_line') }}</div>
              </div>
            </div>

            <div class="bottom-wrap">
              <div class="bottom-title" style="font-weight: 700;">{{ $t('report.count_per_second') }}</div>
              <div class="measure-result-item--pdf measure-result-item-graph" style="position: relative">
                <img src="data:image/png;base64,${readFileSync('public/img/pdf-graph-img.png').toString('base64')}" />
                <div style="position: absolute; top: -40px">
                  <canvas id="graphCanvas-pa" height="200"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="measure-result-item measure-result-item--pdf measure-result-item--ta" :id="[pdfContents-ta]" style="max-height: 380px; max-width:253px">
          <div class="measure-result-item-audio"></div>
          <div class="measure-result-item-top">
            <div class="measure-result-item-title" style="font-weight: 700;">${getGraphText['ta'][0]}</div>
            <div class="measure-result-item-explanation" style="font-weight: 400;">${getGraphText['ta'][1]}</div>
          </div>
          <div class="measure-result-item-main">
            <div class="top-wrap">
              <div class="measure-result-item-img"><img src="data:image/png;base64,${readFileSync('public/img/mouth-ta.png').toString('base64')}"/></div>
              <div style="font-weight: 700;" class="num-wrap">
                ${explanation['ta']}
                <div class="num-explanation" style="font-weight: 400;">{{ $t('report.passing_line') }}</div>
              </div>
            </div>

            <div class="bottom-wrap">
              <div class="bottom-title" style="font-weight: 700;">{{ $t('report.count_per_second') }}</div>
              <div class="measure-result-item--pdf measure-result-item-graph" style="position: relative">
                <img src="data:image/png;base64,${readFileSync('public/img/pdf-graph-img.png').toString('base64')}" />
                <div style="position: absolute; top: -40px">
                  <canvas id="graphCanvas-ta" height="200"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="measure-result-item measure-result-item--pdf measure-result-item--ka" :id="[pdfContents-ka]" style="max-height: 380px; max-width:253px">
          <div class="measure-result-item-audio"></div>
          <div class="measure-result-item-top">
            <div class="measure-result-item-title" style="font-weight: 700;">${getGraphText['ka'][0]}</div>
            <div class="measure-result-item-explanation" style="font-weight: 400;">${getGraphText['ka'][1]}</div>
          </div>
          <div class="measure-result-item-main">
            <div class="top-wrap">
              <div class="measure-result-item-img"><img src="data:image/png;base64,${readFileSync('public/img/mouth-ka.png').toString('base64')}"/></div>
              <div style="font-weight: 700;" class="num-wrap">
                ${explanation['ka']}
                <div class="num-explanation" style="font-weight: 400;">{{ $t('report.passing_line') }}</div>
              </div>
            </div>

            <div class="bottom-wrap">
              <div class="bottom-title" style="font-weight: 700;">{{ $t('report.count_per_second') }}</div>
              <div class="measure-result-item--pdf measure-result-item-graph" style="position: relative">
                <img src="data:image/png;base64,${readFileSync('public/img/pdf-graph-img.png').toString('base64')}" />
                <div style="position: absolute; top: -40px">
                  <canvas id="graphCanvas-ka" height="200"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pdf-bottom">
      <div class="pdf-bottom-date">${endDateTime}</div>
      <div class="pdf-bottom-copyright" style="margin-right: 70px; font-weight: 500;">© 2025 Lion Corporation. All rights reserved.</div>
      <img src="data:image/png;base64,${readFileSync('public/img/logo.png').toString('base64')}" style="width: 51px; height: auto" />
    </div>

  </div>
</div>
</template>
<script>
import BurgerMenuComponent from './BurgerMenu.vue';

export default {
  components: {
    BurgerMenuComponent,
  },
};
</script>
<style lang="scss" scoped>
@import '@/scss/style.scss';

.pdf-contents { 
  padding: 0; 
  margin: 0; 
  max-width: 842px; 
  max-height: 595px; 
  // background-color: #fff; 
  font-family: 'Noto Sans JP', 'Arial', 'sans-serif'; 
}

</style>
